export default "__VITE_ASSET__842a3986__"